import { Preferences } from '@capacitor/preferences';

class NativeStorage {
    async setItem (key, value) {
        try {
            await Preferences.set({
                key: key,
                value: JSON.stringify(value) // Capacitor Preferences solo almacena strings
            });
        } catch (error) {
            console.error('Error setting item', error);
            throw error;
        }
    }

    async removeItem (key) {
        try {
            await Preferences.remove({ key: key });
        } catch (error) {
            console.error('Error removing item', error);
            throw error;
        }
    }

    async getItem (key) {
        try {
            const { value } = await Preferences.get({ key: key });
            return value ? JSON.parse(value) : null; // Parsear el valor si es JSON
        } catch (error) {
            console.error('Error getting item', error);
            throw error;
        }
    }

    async clear () {
        try {
            await Preferences.clear();
        } catch (error) {
            console.error('Error clearing storage', error);
            throw error;
        }
    }
}

export default NativeStorage;



// WEBPACK FOOTER //
// ./src/services/cache/NativeStorage.js